import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import ModalEditAmenity from './ModalEditAmenity';
import { AMENITY_SPACE_STATUS } from '../../../../../constants/event-application-status';

function EditEventSurchargeList({ eventSurchargeList, onDelete, setList }) {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [selectedItem, setItem] = useState(null);

  const openModalUpdate = (item) => {
    setItem(item);
    setOpen(true);
  };

  const onSave = (values) => {
    setList(
      eventSurchargeList.map((item) =>
        item.id === selectedItem.id ? { ...item, name: values.name, price: values.price } : item,
      ),
    );
    setOpen(false);
  };

  return (
    // <List sx={{ width: '100%' }}>
    //   <ListItem divider key="header" disableGutters>
    //     <ListItemText
    //       primary="Name"
    //       sx={{ fontWeight: 600 }}
    //       primaryTypographyProps={{ style: fontStyle }}
    //     />
    //     <p style={{ marginRight: '20%' }}>
    //       <strong>Price</strong>
    //     </p>
    //   </ListItem>

    //   {eventSurchargeList.map(
    //     (item) =>
    //       item.status === AMENITY_SPACE_STATUS.ENABLED && (
    //         <ListItem
    //           divider
    //           key={item.key}
    //           disableGutters
    //           secondaryAction={
    //             <Box>
    //               <Box sx={{ paddingRight: '15px', display: 'inline' }}>
    //                 <IconButton
    //                   edge="end"
    //                   aria-label="delete"
    //                   onClick={() => openModalUpdate(item)}>
    //                   <EditIcon />
    //                 </IconButton>
    //               </Box>
    //               <Box sx={{ display: 'inline' }}>
    //                 <IconButton edge="end" aria-label="delete" onClick={onDelete(item)}>
    //                   <DeleteIcon />
    //                 </IconButton>
    //               </Box>
    //             </Box>
    //           }>
    //           <ListItemText primary={item.name} />
    //           <p style={{ color: '#0997BA', fontWeight: 'bold', marginRight: '15%' }}>
    //             ${item.price}
    //           </p>
    //         </ListItem>
    //       ),
    //   )}

    //   {open && (
    //     <ModalEditAmenity
    //       open={open}
    //       amenity={selectedItem}
    //       handleClose={handleClose}
    //       onSave={onSave}
    //     />
    //   )}
    // </List>
    <TableContainer component={Paper} style={{ borderRadius: 20, marginTop: 20 }}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">
              <Box sx={{ fontWeight: 'bold' }}>Name</Box>
            </TableCell>
            <TableCell align="left" xs={{ fontWeight: 600 }}>
              <Box sx={{ fontWeight: 'bold' }}>Price</Box>
            </TableCell>
            <TableCell align="left" xs={{ fontWeight: 600 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {
            // eslint-disable-next-line react/prop-types
            eventSurchargeList?.map(
              (row, i) =>
                row.status === AMENITY_SPACE_STATUS.ENABLED && (
                  <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">
                      <p style={{ color: '#0997BA', fontWeight: 'bold', marginRight: '15%' }}>
                        ${row.price}
                      </p>
                    </TableCell>
                    <TableCell align="right">
                      <Box>
                        <Box sx={{ paddingRight: '15px', display: 'inline' }}>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => openModalUpdate(row)}>
                            <EditIcon />
                          </IconButton>
                        </Box>
                        <Box sx={{ display: 'inline' }}>
                          <IconButton edge="end" aria-label="delete" onClick={onDelete(row)}>
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                ),
            )
          }
        </TableBody>
      </Table>

      {open && (
        <ModalEditAmenity
          open={open}
          amenity={selectedItem}
          handleClose={handleClose}
          onSave={onSave}
        />
      )}
    </TableContainer>
  );
}

EditEventSurchargeList.propTypes = {
  onDelete: PropTypes.func.isRequired,
  eventSurchargeList: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  setList: PropTypes.func.isRequired,
};

export default EditEventSurchargeList;
